import { useLocation } from 'react-router-dom';
import { Flex, Box, Text, ChakraBaseProvider } from "@chakra-ui/react";
import LaunchdeckButton from './LaunchdeckButton';
import { redirectToNewPage } from '../../../helpers/global-helpers';
import PublicUserHeader from '../../../../auth/components/PublicUserHeader';
import claverTheme from '../../../../layout/components/layout/components/theme/claverTheme';
import SleepingMascotImage from './SleepingMascotImage';


export default function PublicErrorPage() {

	const location = useLocation();
	const { redirectionUri } = location.state || {};

	return (
		<ChakraBaseProvider theme={claverTheme}>
		<PublicUserHeader 
			signUpEnabled 
			showBackOption= {redirectionUri ? true : false}
			previousRoute={redirectionUri}
			/>

		<Flex direction="column" align="center" bg='white' p='3%' mb='2em' rounded='0.8em'>
			<Box fontSize='1.2em' fontWeight='600'>Page not found</Box>
			<Text mt='0.2em'>But you've found Gnocco, our Chief Doggo Officer, napping here instead!</Text>
			
			<SleepingMascotImage />

			<Flex direction='column' mt='1em' justify='center' alignItems='center'>
				<Flex justify={['center', 'flex-end', 'flex-end', 'flex-end']} w='100%'>
					<LaunchdeckButton bg='brand.500' color='white' onClick={() => redirectToNewPage(redirectionUri ? redirectionUri : '/signup')} label='Ssshh...quietly head back?' />
				</Flex>
			</Flex>

		</Flex>

		</ChakraBaseProvider>

		
	)
}

